import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:35
* @route 'https://org.proexpert.app/org/login'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/login',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:35
* @route 'https://org.proexpert.app/org/login'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:35
* @route 'https://org.proexpert.app/org/login'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:35
* @route 'https://org.proexpert.app/org/login'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgLoginController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgLoginController.php:35
* @route 'https://org.proexpert.app/org/login'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const login = {
    store: Object.assign(store, store),
}

export default login